import { toolJsonLd, toolPath, type Tool } from "../../seo/tools";
import { breadcrumbJsonLd, faqJsonLd } from "../../seo/site";

export const toolInputClass =
  "w-full rounded-xl border border-slate-300 bg-white px-3.5 py-2.5 text-base text-slate-900 placeholder:text-slate-400 focus:border-violet-500 focus:outline-none focus:ring-2 focus:ring-violet-200";
export const toolLabelClass = "block text-sm font-semibold text-slate-700 mb-1.5";

/** Head tags for a tool page; the pre-renderer writes the same values (seo/prerenderRoutes.ts). */
export function toolSeo(tool: Tool) {
  return {
    title: `${tool.title} | DealHawk`,
    description: tool.description,
    path: toolPath(tool.slug),
    jsonLd: [
      toolJsonLd(tool),
      faqJsonLd(tool.faq),
      breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Free tools", path: "/tools" }, { name: tool.navLabel }]),
    ],
  };
}
